// Camp Jain Animations with ScrollMagic and GSAP
class ClubCaddyAnimations {
  constructor() {
    this.controller = null;
    this.init();
  }

  async init() {
    // Éviter la double initialisation
    if (window.campAnimationsInitialized) {
      return;
    }

    // Vérifier si ScrollMagic et GSAP sont chargés
    if (typeof ScrollMagic === 'undefined' || typeof gsap === 'undefined') {

      return;
    }

    this.controller = new ScrollMagic.Controller();

    window.campAnimationsInitialized = true;

    // Ajouter une classe pour indiquer que les animations sont prêtes
    document.body.classList.add('clubcaddy-animations-ready');

    this.setupAnimations();
  }

  setupAnimations() {
    // this.imageChangeOnScroll();
    // this.horizontalScrollSection();
    this.reviewsSection();
    this.parrallaxImages();
    this.section5ImagesAnimation();

    // Gérer le redimensionnement de fenêtre
    window.addEventListener('resize', () => {
      // Réinitialiser les animations après un délai
      setTimeout(() => {
        if (this.controller) {
          this.controller.destroy();
          this.controller = new ScrollMagic.Controller();
          // this.imageChangeOnScroll();
          // this.horizontalScrollSection();
          this.reviewsSection();
          this.parrallaxImages();
          this.section5ImagesAnimation();
        }
      }, 300);
    });
  }

  parrallaxImages() {
    // effet parallax léger au sroll sur les images avec la class "club-caddy-parallax"
    const parallaxImages = document.querySelectorAll('.club-caddy-parallax');

    parallaxImages.forEach((image) => {
      const scene = new ScrollMagic.Scene({
        triggerElement: image,
        triggerHook: 1,
        duration: '200%'
      })
        .setTween(gsap.fromTo(image, { y: '10%' }, { y: '-20%', ease: 'none' }))
        .addTo(this.controller);
    });
  }

  imageChangeOnScroll() {
    const section = document.querySelector('.club-caddy__section1');
    const imageContainers = document.querySelectorAll('.club-caddy__images');
    const stickyInner = document.querySelector('.club-caddy__section1-inner');

    if (!section || imageContainers.length === 0 || !stickyInner) {
      return;
    }

    // Vérifier si on est sur mobile
    const isMobile = window.innerWidth <= 993;

    if (isMobile) {
      this.setupMobileAnimation(section, imageContainers[0]);
    } else {
      this.setupDesktopAnimation(section, imageContainers);
    }
  }

  setupDesktopAnimation(section, imageContainers) {
    if (imageContainers.length < 2) {
      return;
    }

    // Récupérer les images de gauche et de droite séparément
    const leftImages = imageContainers[0].querySelectorAll('.club-caddy__image');
    const rightImages = imageContainers[1].querySelectorAll('.club-caddy__image');

    if (leftImages.length === 0 || rightImages.length === 0) {
      return;
    }

    // Masquer toutes les images au début
    leftImages.forEach(img => img.classList.remove('active'));
    rightImages.forEach(img => img.classList.remove('active'));

    // Afficher la première image par défaut des deux côtés
    if (leftImages[0] && rightImages[0]) {
      leftImages[0].classList.add('active');
      rightImages[0].classList.add('active');
    }

    // Créer une scène ScrollMagic qui se déclenche quand la section atteint le haut
    const scene = new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0, // Se déclenche quand la section atteint le haut de l'écran
      duration: section.offsetHeight - window.innerHeight // Durée pendant laquelle c'est sticky
    })
      .on('progress', (event) => {
        const progress = event.progress; // 0 à 1

        // Définir la séquence : 1 → 2 → 3 → 2 → 1 → 2 → 3 (7 frames)
        // On divise le progress en 6 étapes égales pour 7 positions
        let imageIndex;
        const step = progress * 6; // 0 à 6

        if (step < 1) {
          imageIndex = 0; // Image 1
        } else if (step < 2) {
          imageIndex = 1; // Image 2
        } else if (step < 3) {
          imageIndex = 2; // Image 3
        } else if (step < 4) {
          imageIndex = 1; // Image 2 (retour)
        } else if (step < 5) {
          imageIndex = 0; // Image 1 (retour)
        } else if (step < 6) {
          imageIndex = 1; // Image 2 (retour 2)
        } else {
          imageIndex = 2; // Image 3 (final)
        }

        // Masquer toutes les images des deux côtés
        leftImages.forEach(img => img.classList.remove('active'));
        rightImages.forEach(img => img.classList.remove('active'));

        // Afficher les images correspondantes des deux côtés
        if (leftImages[imageIndex] && rightImages[imageIndex]) {
          leftImages[imageIndex].classList.add('active');
          rightImages[imageIndex].classList.add('active');
        }
      })
      .addTo(this.controller);
  }

  setupMobileAnimation(section, imageContainer) {
    const images = imageContainer.querySelectorAll('.club-caddy__image');

    if (images.length === 0) {
      return;
    }

    // Déterminer le nombre d'images visibles selon la taille d'écran
    const isSmallScreen = window.innerWidth < 750;
    const visibleImages = isSmallScreen ? 2 : 3;

    // Positions initiales
    this.setMobileImagePositions(images, 0, visibleImages);

    // Créer une scène ScrollMagic pour mobile
    const scene = new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0,
      duration: section.offsetHeight - window.innerHeight
    })
      .on('progress', (event) => {
        const progress = event.progress; // 0 à 1

        let positionIndex;

        // 6 frames pour tous les écrans
        if (progress < 0.167) { // 1/6
          positionIndex = 0;
        } else if (progress < 0.333) { // 2/6
          positionIndex = 1;
        } else if (progress < 0.5) { // 3/6
          positionIndex = 2;
        } else if (progress < 0.667) { // 4/6
          positionIndex = 3;
        } else if (progress < 0.833) { // 5/6
          positionIndex = 4;
        } else { // 6/6
          positionIndex = 5;
        }

        // Appliquer les positions de façon brusque
        this.setMobileImagePositions(images, positionIndex, visibleImages);
      })
      .addTo(this.controller);
  }

  setMobileImagePositions(images, positionIndex, visibleImages = 3) {
    // Définir les arrangements selon le nombre d'images visibles - 6 frames pour tous
    let arrangements;

    if (visibleImages === 2) {
      // Pour 2 images : séquences où toutes les images changent à chaque fois
      arrangements = [
        [0, 1], // Frame 1 : Image1-Image2
        [2, 0], // Frame 2 : Image3-Image1 (toutes changent)
        [1, 2], // Frame 3 : Image2-Image3 (toutes changent)
        [0, 1], // Frame 4 : Image1-Image3 (toutes changent)
        [2, 0], // Frame 5 : Image3-Image2 (toutes changent)
        [1, 2], // Frame 6 : Image2-Image1 (toutes changent)
      ];
    } else {
      // Pour 3 images : séquences où toutes les images changent de position
      arrangements = [
        [0, 1, 2], // Frame 1 : Image1-Image2-Image3
        [1, 2, 0], // Frame 2 : Image3-Image1-Image2 (toutes changent)
        [2, 0, 1], // Frame 3 : Image2-Image3-Image1 (toutes changent)
        [0, 1, 2], // Frame 4 : Image1-Image3-Image2 (toutes changent)
        [1, 2, 0], // Frame 5 : Image3-Image2-Image1 (toutes changent)
        [2, 0, 1], // Frame 6 : Image2-Image1-Image3 (toutes changent)
      ];
    }

    const currentArrangement = arrangements[positionIndex % arrangements.length];

    // Supprimer toutes les classes center
    images.forEach(img => {
      img.classList.remove('center');
      img.style.order = '';
      img.style.display = ''; // Reset display
    });

    // Pour les petits écrans, masquer toutes les images d'abord
    if (visibleImages === 2) {
      images.forEach(img => {
        img.style.display = 'none';
      });
    }

    // Réorganiser les images selon l'arrangement actuel
    currentArrangement.forEach((imageIndex, position) => {
      const img = images[imageIndex];
      if (img) {
        img.style.display = 'flex'; // Afficher cette image
        img.style.order = position;

        // Pour 2 images : mettre en avant la première
        // Pour 3 images : mettre en avant celle du milieu (position 1)
        const centerPosition = visibleImages === 2 ? 0 : 1;
        if (position === centerPosition) {
          img.classList.add('center');
        }
      }
    });
  }

  horizontalScrollSection() {
    const section2 = document.querySelector('.club-caddy__section2');
    const image = section2 ? section2.querySelector('img') : null;

    if (!section2 || !image) {
      console.log('Section 2 ou image non trouvée');
      return;
    }

    // Attendre que l'image soit chargée pour calculer ses dimensions
    const setupHorizontalScroll = () => {
      const imageWidth = image.naturalWidth;
      const imageHeight = image.naturalHeight;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // Récupérer la vitesse depuis le data-attribute ou utiliser la valeur par défaut
      const scrollSpeed = parseFloat(section2.dataset.scrollSpeed) || 2;

      // Calculer la hauteur de la section basée sur la vitesse
      const sectionHeight = scrollSpeed * viewportHeight;

      // Calculer la largeur affichée de l'image quand elle remplit la hauteur
      const displayedImageWidth = (imageWidth * viewportHeight) / imageHeight;

      // Distance à parcourir pour voir toute l'image
      const scrollDistance = Math.max(0, displayedImageWidth - viewportWidth);

      console.log('Scroll speed:', scrollSpeed, 'Section height:', sectionHeight, 'Scroll distance:', scrollDistance);

      if (scrollDistance > 0) {
        // Créer une scène ScrollMagic pour le scroll horizontal
        const scene = new ScrollMagic.Scene({
          triggerElement: section2,
          triggerHook: 0, // Se déclenche quand la section atteint le haut (devient sticky)
          duration: sectionHeight - viewportHeight // Durée basée sur la vitesse configurée
        })
          .on('progress', (event) => {
            const progress = event.progress; // 0 à 1

            // Calculer la position horizontale de l'image
            const translateX = -progress * scrollDistance;

            // Appliquer la transformation
            image.style.transform = `translateX(${translateX}px)`;

            console.log('Section 2 progress:', progress, 'translateX:', translateX);
          })
          .addTo(this.controller);

        console.log('Animation scroll horizontal configurée - Distance:', scrollDistance + 'px');
      } else {
        console.log('Image pas assez large pour le scroll horizontal');
      }
    };

    // Si l'image est déjà chargée
    if (image.complete && image.naturalWidth > 0) {
      setupHorizontalScroll();
    } else {
      // Attendre le chargement de l'image
      image.addEventListener('load', setupHorizontalScroll);
    }
  }

  reviewsSection() {
    const section3 = document.querySelector('.club-caddy__section3');
    const reviews = document.querySelectorAll('.club-caddy__review');

    if (!section3 || reviews.length === 0) {
      console.log('Section 3 ou reviews non trouvées');
      return;
    }

    // État initial des reviews : invisibles et petites
    reviews.forEach((review, index) => {
      review.style.opacity = '0';
      review.style.transform = 'scale(0)';
    });

    // Scene simple : quand on arrive dans la section
    const scene3 = new ScrollMagic.Scene({
      triggerElement: section3,
      triggerHook: 0.8, // Se déclenche quand la section est à 80% visible
      duration: 0 // Pas de durée, juste un trigger
    })
      .on('enter', () => {
        console.log('Déclenchement animations reviews');
        this.startReviewsAnimation(reviews);
      })
      .addTo(this.controller);

    console.log('Animation section reviews configurée (simple)');
  }

  startReviewsAnimation(reviews) {
    reviews.forEach((review, index) => {
      // Délai échelonné pour chaque review
      const delay = index * 150; // 150ms entre chaque

      setTimeout(() => {
        // Animation d'apparition
        gsap.to(review, {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          ease: "back.out(1.7)", // Joli effet bounce
          onComplete: () => {
            // Démarrer le flottement après l'apparition
            this.createFloatingAnimation(review, index);
          }
        });
      }, delay);
    });
  }

  createFloatingAnimation(review, index) {
    // Animation de flottement simple sans rotation
    const duration = 3 + Math.random() * 2; // Entre 3 et 5 secondes
    const delay = index * 0.2; // Délai échelonné

    // Animation de flottement vertical uniquement
    gsap.to(review, {
      y: "+=8",
      duration: duration,
      ease: "power1.inOut",
      yoyo: true,
      repeat: -1,
      delay: delay
    });
  }

  section5ImagesAnimation() {
    const section5 = document.querySelector('.club-caddy__fl-imgs');
    const images = document.querySelectorAll('.club-caddy__fl-img');

    if (!section5 || images.length === 0) {
      return;
    }

    // État initial des images : invisibles et décalées vers le bas
    images.forEach((image, index) => {
      gsap.set(image, {
        opacity: 0,
        y: 100, // Décalage vers le bas pour l'effet slideUp
      });
    });

    // Scene ScrollMagic : se déclenche à 50% de la section
    const scene5 = new ScrollMagic.Scene({
      triggerElement: section5,
      triggerHook: 0.8, // Se déclenche à 30% de l'écran
      duration: 0 // Juste un trigger
    })
      .on('enter', () => {
        this.animateSection5Images(images);
      })
      .addTo(this.controller);
  }

  animateSection5Images(images) {
    images.forEach((image, index) => {
      // Délai échelonné entre les deux images
      const delay = index * 100; // delai entre chaque image pour plus de fluidité

      setTimeout(() => {
        // Animation slideUp + opacity plus fluide
        gsap.to(image, {
          opacity: 1,
          y: 0,
          duration: 1.2, // Durée plus longue pour plus de fluidité
          ease: "power2.out", // Courbe plus douce
          onComplete: () => {
            // Démarrer le flottement après l'apparition
            this.createImageFloating(image, index);
          }
        });
      }, delay);
    });
  }

  createImageFloating(image, index) {
    // Animation de flottement pour les images
    const duration = 3;
    const floatDistance = 10;

    // Flottement vertical avec une petite variation d'amplitude
    gsap.to(image, {
      y: `+=${floatDistance}`,
      duration: duration,
      ease: "power3.inOut",
      yoyo: true,
      repeat: -1,
      delay: index * 0.5 // Délai pour désynchroniser les flottements
    });
  }

}

// Fonction d'initialisation
function initAnimations() {
  // Vérifier si les éléments existent
  const campBlock = document.querySelector('.club-caddy-content');

  if (campBlock) {
    new ClubCaddyAnimations();
  } else {
    setTimeout(initAnimations, 1000);
  }
}

// Initialiser les animations selon l'état du DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAnimations();
  });
} else {
  initAnimations();
}

// Backup - essayer aussi avec window.onload
window.addEventListener('load', () => {
  initAnimations();
});

// Exporter pour utilisation globale
window.ClubCaddyAnimations = ClubCaddyAnimations;